import { atom } from "jotai";
import { MetricQuery } from "./metrics.types";
import { getLocalStorage, LocalStorageKey } from "@/features/LocalStorage";

export const metricStackAtom = atom<MetricQuery[]>(
    getLocalStorage(LocalStorageKey.MetricLab)?.metricStack || [],
);

export const selectedPeriodAtom = atom<string | null>(null);
